/**
 * localStorage persistence for the Data Domains module — the reviewer's
 * accept/reject/reassign decisions and any user-defined custom domains.
 * Suggestions themselves are recomputed live from the dataset schemas.
 */

import type { AssignmentStatus, DataDomain, DomainSource } from '@/features/domains/types';

const DECISIONS_KEY = 'edc.decisions.v1';
const CUSTOM_KEY = 'edc.customDomains.v1';

export interface StoredDecision {
  domainId: string | null;
  status: AssignmentStatus;
  source: DomainSource;
}

export function loadDecisions(): Record<string, StoredDecision> {
  try {
    const raw = localStorage.getItem(DECISIONS_KEY);
    return raw ? (JSON.parse(raw) as Record<string, StoredDecision>) : {};
  } catch {
    return {};
  }
}

export function saveDecisions(decisions: Record<string, StoredDecision>): void {
  localStorage.setItem(DECISIONS_KEY, JSON.stringify(decisions));
}

export function loadCustomDomains(): DataDomain[] {
  try {
    const raw = localStorage.getItem(CUSTOM_KEY);
    return raw ? (JSON.parse(raw) as DataDomain[]) : [];
  } catch {
    return [];
  }
}

export function saveCustomDomains(domains: DataDomain[]): void {
  localStorage.setItem(CUSTOM_KEY, JSON.stringify(domains));
}
